import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { LatLngLiteral } from '@agm/core';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { PartnerSite } from 'src/app/assabil-kernel/models/entities/control-tables/partner-site-entity';
import { marker } from 'src/app/tools/models/entities/marker';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { PartnerPipe } from 'src/app/assabil-kernel/pipes/partner-pipe';
import { UserService } from 'src/app/assabil-kernel/services/user-service';



@Component({
  selector: 'partner-widget',
  templateUrl: './partner-widget.component.html',
  styleUrls: ['./partner-widget.component.scss']
})

export class PartnerWidgetComponent extends BaseWidget {

  partnerPipe            : PartnerPipe = new PartnerPipe();
  showInMap           : boolean = false;
  
  partner             : Partner = new Partner();
  partnerSites        : PartnerSite[] = [];

  partnerSiteColumns = [
    { prop: 'partnerCode',      name: 'Code Partenaire', },
    { prop: 'partnerSiteCode',  name: 'Code Site', },
    { prop: 'name',             name: 'Name' },
    { prop: 'name',             name: 'Name' },

    
    { prop: 'branchCode',       name: 'Agence' },
    { prop: 'distanceToBranch', name: 'Distance' },
    { prop: 'timeToBranch',     name: 'Temps' },
  ]
  
  constructor(
    protected masterDataService : MasterDataService,
    protected toastr            : ToastrService,
    protected leanUtilsService  : LeanUtilsService,
    protected router            : Router,
    protected activatedRoute    : ActivatedRoute,
    public    userService       : UserService) {
      super(toastr, leanUtilsService);

  }

  //------------------------------------------------------
  setEntity(partner: Partner) {
    this.partner = { ...partner };
    this.buildPoints();
    this.loadDetails();
  }
  getEntity(){
    return this.partner;
  }
  //------------------------------------------------------

  //------------------------------------------------------
    saveRow() : Promise<Partner>{
      return this.masterDataService.partnerSave(this.partner);
  }
  //------------------------------------------------------

  loadDetails(){
    this.masterDataService.partnerSitesGet(this.partner.partnerCode).then(result => {
      this.partnerSites = result;
    })
  }
  
  selectedPartnerSite : PartnerSite;
  selectPartnerSite(partnerSite : PartnerSite){
    this.selectedPartnerSite = partnerSite;
//      this.router.navigate(['../partner-site-widget', partnerSite.partner.partnerCode, partnerSite.partnerSiteCode], {relativeTo : this.activatedRoute});
  }


  onMapClick(point : LatLngLiteral){
    if (this.partner.edit){
      this.partner.latitude = point.lat;
      this.partner.longitude = point.lng;
    }
  }

  points : marker[] = [];
  buildPoints(){
      let point : marker = {     
        lat: this.partner.latitude,
        lng: this.partner.longitude,
        label: this.partner.name,
        draggable: false,
        iconUrl: 'http://maps.google.com/mapfiles/ms/icons/green.png'
      };
    
      this.points.push(point);
    }

  //----------------------------------------------------------------------
  validateProspect(){
    this.masterDataService.prospectValidate(this.partner.partnerCode).then(partner => {
      this.partner = partner;
      this.showSuccessFulOperation();
  })
}
//----------------------------------------------------------------------

    
closeWidget(){
  this.selectedPartnerSite = null;
}
}
